/* import __COLOCATED_TEMPLATE__ from './completion-screen-settings.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();